import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Col, Row } from "reactstrap"
import { getOrderDetails, getProductOrders } from "store/actions"
import OrdersFilterForm from "./ordersFilterForm"
import ordersListColumns from "./ordersListColumns"

const OrdersTab = ({ orders, getProductOrders, history, getOrderDetails }) => {
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "desc",
  })

  useEffect(() => {
    getProductOrders({ ...defaultOrder, page: 1, per_page: 50 })
  }, [])

  const actions = [
    {
      name: "View",
      onClick: item => {
        history.push(`/orders/${item.id}`)
      },
      icon: "bx bx-show-alt",
      isAvailable: true,
    },
  ]

  return (
    <React.Fragment>
      <OrdersFilterForm defaultOrder />
      <Row className="my-2">
        <Col>
          <TableComponent
            columns={ordersListColumns()}
            data={orders?.data || []}
            actions={actions}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  orders: state.ProductsAndSubscriptions.orders,
})

const mapDispatchToProps = dispatch => ({
  getProductOrders: values => dispatch(getProductOrders(values)),
  getOrderDetails: values => dispatch(getOrderDetails(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OrdersTab))
